/**
 * Registers the ZoomPay service worker (production builds only) and announces
 * new versions with a 'zp-sw-update' window event, which UpdateBanner shows.
 */
export function register() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return;
  const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
  if (publicUrl.origin !== window.location.origin) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/service-worker.js`)
      .then((registration) => {
        const announce = (worker) =>
          window.dispatchEvent(new CustomEvent('zp-sw-update', { detail: { worker } }));
        if (registration.waiting && navigator.serviceWorker.controller) announce(registration.waiting);
        registration.addEventListener('updatefound', () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            // A new version is ready while an old one controls the page.
            if (installing.state === 'installed' && navigator.serviceWorker.controller) announce(installing);
          });
        });
        // Look for new releases when the app comes back to the foreground, and hourly.
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') registration.update().catch(() => {});
        });
        setInterval(() => registration.update().catch(() => {}), 60 * 60 * 1000);
      })
      .catch((err) => console.error('Service worker registration failed:', err));

    // Reload only when the customer tapped "Refresh" on the update banner - never
    // on a first install, so nobody loses a half-filled form to a surprise reload.
    let reloaded = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloaded || !window.__zpSwRefreshRequested) return;
      reloaded = true;
      window.location.reload();
    });
  });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((r) => r.unregister()).catch(() => {});
  }
}
